import script from "./ResultScreen.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResultScreen.vue?vue&type=script&lang=ts&setup=true"

import "./ResultScreen.vue?vue&type=style&index=0&id=8bb40978&lang=scss"

const __exports__ = script;

export default __exports__